
import { useState, useEffect } from 'react';
import { savePaymentCredentials, getPaymentCredentials } from '@/lib/supabase/payments/paymentCredentials';
import { PaymentProvider, EcomPaymentCredentials } from '@/lib/supabase/payments/types';
import { toast } from 'sonner';

export const usePaymentCredentials = (shopId: string, provider: PaymentProvider) => {
  const [apiKey, setApiKey] = useState('');
  const [apiSecret, setApiSecret] = useState('');
  const [isSaving, setIsSaving] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Fetch existing credentials when the dialog opens
  useEffect(() => {
    const fetchCredentials = async () => {
      setIsLoading(true);
      try {
        const credentials = await getPaymentCredentials(shopId, provider);
        if (credentials) {
          setApiKey(credentials.api_key || '');
          setApiSecret(credentials.api_secret || '');
        }
      } catch (error) {
        console.error(`Erreur lors de la récupération des identifiants ${provider}:`, error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchCredentials();
  }, [shopId, provider]);

  const handleSaveCredentials = async () => {
    if (!apiKey || !apiSecret) {
      toast.error('Veuillez remplir tous les champs');
      return;
    }

    setIsSaving(true);
    try {
      const result = await savePaymentCredentials(shopId, {
        provider,
        api_key: apiKey,
        api_secret: apiSecret
      });
      
      if (result.success) {
        toast.success(`Identifiants ${provider} enregistrés`);
        return true;
      } else {
        toast.error(`Erreur lors de l'enregistrement des identifiants ${provider}`);
        return false;
      }
    } catch (error) {
      console.error(`Erreur lors de l'enregistrement des identifiants ${provider}:`, error);
      toast.error(`Erreur lors de l'enregistrement des identifiants`);
      return false;
    } finally {
      setIsSaving(false);
    }
  };

  return {
    apiKey,
    setApiKey,
    apiSecret,
    setApiSecret,
    isSaving,
    isLoading,
    handleSaveCredentials
  };
};
